module.exports = __webpack_public_path__ + "static/sec9-bg-09519304b838309ad9b5d58a608b52ba.jpg";